import { Stack, Typography } from "@mui/material";
import { ReuseModal } from "../../ReuseModal";

type Props = {
  onClose: () => void;
  onSubmit: () => void;
};

export const ConfirmRemovePlaybooksModal = ({ onClose, onSubmit }: Props) => {
  const submitHandler = () => {
    onSubmit();
    onClose();
  };

  return (
    <ReuseModal
      isOpen={true}
      onClose={onClose}
      title="Delete Playbooks"
      maxWidth="430px"
      submitBtnText="Delete"
      submitBtnColor="#C0392B"
      onSubmit={submitHandler}
    >
      <Stack gap={"12px"} paddingBottom={"16px"} paddingTop={"8px"}>
        <Typography
          component="span"
          variant="subtitle1"
          sx={{ color: "#464646" }}
        >
          Are you sure you want to delete Playbooks from the selected companies?
        </Typography>
        <Typography
          component="span"
          variant="subtitle1"
          sx={{ color: "#464646" }}
        >
          You’ll need to generate it again if you need it later.
        </Typography>
      </Stack>
    </ReuseModal>
  );
};
